export default __webpack_public_path__ + "static/media/download.fed6ccfe.svg";